import { atom } from 'jotai'
import { UseSubscriptionResponse } from 'urql'
import {
  GetAvailableTestTagsSubscription,
  GetProfilesSubscription,
  GetProfilesSubscriptionVariables,
  GetAvailableTestTagsSubscriptionVariables,
  GetAttentionOrdersSubscription,
  GetAttentionOrdersSubscriptionVariables,
  GetAvailableLaboratoriesSubscription,
  GetAvailableLaboratoriesSubscriptionVariables,
  GetAvailableTestsMostPopularSubscription,
  GetAvailableTestsMostPopularSubscriptionVariables,
  GetClientFavouriteTestsSubscription,
  GetClientFavouriteTestsSubscriptionVariables,
} from '../generated/urql.client'
import {
  GetConsultationsSubscription,
  GetConsultationsSubscriptionVariables,
  GetFeatureFlagsSubscription,
  GetFeatureFlagsSubscriptionVariables,
  GetTrainingsSubscription,
  GetTrainingsSubscriptionVariables,
} from '../generated/urql.anonymous'

const initialState = {
  fetching: true,
  stale: false,
}

export const profilesSubscriptionAtom = atom<
  UseSubscriptionResponse<
    GetProfilesSubscription,
    GetProfilesSubscriptionVariables
  >
>([initialState, () => {}])

export const availableTestTagsSubscriptionAtom = atom<
  UseSubscriptionResponse<
    GetAvailableTestTagsSubscription,
    GetAvailableTestTagsSubscriptionVariables
  >
>([initialState, () => {}])

export const attentionOrdersSubscriptionAtom = atom<
  UseSubscriptionResponse<
    GetAttentionOrdersSubscription,
    GetAttentionOrdersSubscriptionVariables
  >
>([initialState, () => {}])

export const availableLaboratoriesSubscriptionAtom = atom<
  UseSubscriptionResponse<
    GetAvailableLaboratoriesSubscription,
    GetAvailableLaboratoriesSubscriptionVariables
  >
>([initialState, () => {}])

export const availableTestsMostPopularSubscriptionAtom = atom<
  UseSubscriptionResponse<
    GetAvailableTestsMostPopularSubscription,
    GetAvailableTestsMostPopularSubscriptionVariables
  >
>([initialState, () => {}])

export const consultationsSubscriptionAtom = atom<
  UseSubscriptionResponse<
    GetConsultationsSubscription,
    GetConsultationsSubscriptionVariables
  >
>([initialState, () => {}])

export const trainingsSubscriptionAtom = atom<
  UseSubscriptionResponse<
    GetTrainingsSubscription,
    GetTrainingsSubscriptionVariables
  >
>([initialState, () => {}])

export const clientFavouriteTestsSubscriptionAtom = atom<
  UseSubscriptionResponse<
    GetClientFavouriteTestsSubscription,
    GetClientFavouriteTestsSubscriptionVariables
  >
>([initialState, () => {}])

export const featureFlagsSubscriptionAtom = atom<
  UseSubscriptionResponse<
    GetFeatureFlagsSubscription,
    GetFeatureFlagsSubscriptionVariables
  >
>([initialState, () => {}])
